module.exports = __webpack_public_path__ + "img/bh.8d2518cb.svg";